var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-input" }, [
    _c("div", { staticClass: "viq-input__container" }, [
      _c("div", { staticClass: "viq-input__field-wrap" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputText,
              expression: "inputText",
            },
          ],
          ref: "textarea",
          staticClass: "viq-input__textarea",
          attrs: {
            placeholder: _vm.placeholder,
            rows: "1",
            disabled: _vm.isStreaming,
          },
          domProps: { value: _vm.inputText },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.inputText = $event.target.value
              },
              _vm.autoResize,
            ],
            keydown: _vm.handleKeydown,
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "viq-input__submit",
            attrs: {
              disabled: !_vm.canSubmit,
              title: _vm.isStreaming ? "Stop" : "Ask",
            },
            on: { click: _vm.handleSubmit },
          },
          [
            !_vm.isStreaming
              ? [_vm._v("Ask")]
              : _c(
                  "svg",
                  {
                    attrs: {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        x: "3",
                        y: "3",
                        width: "10",
                        height: "10",
                        rx: "1",
                        fill: "currentColor",
                      },
                    }),
                  ]
                ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "viq-input__footer" }, [
      _c("span", { staticClass: "viq-input__disclaimer" }, [
        _vm._v(
          "\n        VIQ uses AI across Vixio's proprietary data only. Always verify critical information from official sources before making decisions.\n      "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }